<template>
  <div class="from_box flex">
    <!-- <div class="item">
      <span class="txt">生产订单：</span>
      <el-input
        v-model="fromData.productOrderNo"
        clearable
        placeholder="请输入生产订单号"
        @keyup.enter.native="enterGetSaleData($event)"
      ></el-input>
    </div> -->
    <!-- 新增弹窗 -->
      <el-dialog
        width="900px"
        customClass="dialog_detail_style"
        title="选择生产订单号"
        :visible.sync="dialogSelectMatters"
        @close="cancelSelect"
        v-dialogDrag 
      >
        <prodorder-input-list
          class="contnet_box"
          ref="selectMatter"
          :selectedList="selectedMatterSaleList"
          @selectSdata="selectSdata"
        ></prodorder-input-list>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelSelect">取 消</el-button>
          <el-button type="primary" @click="selectMattersOk">确 定</el-button>
        </div>
      </el-dialog>

    <div class="item">
      <span class="txt">生产订单：</span>
      <el-input placeholder="点击右侧搜索" @change="prodOrderNoChange" :disabled="true" v-model="fromData.productOrderNo"  class="input-with-select">
        <el-button slot="append" @click="enterGetSaleData(fromData.productOrderNo)"  icon="el-icon-search"></el-button>
      </el-input>
    </div>

    <!-- <div class="item">
      <span class="txt">工厂：</span>
      <el-autocomplete
        :disabled="true"
        v-model="fromData.factoryStr"
        :fetch-suggestions="factoryQuerySearchAsync"
        :trigger-on-focus="false"
        placeholder="暂无工厂"
        @select="handleSelectFactory"
        @keyup.enter.native="enterHandleSelectFactory"
        @blur="enterHandleSelectFactory"
        ref="factoryAuto"
        clearable
        @clear="factoryClear"
      ></el-autocomplete>
    </div> -->

    <div class="item">
      <span class="txt">工厂：</span>
      <el-input v-model="fromData.planFactoryDesc" :disabled="true" placeholder="暂无工厂" ></el-input>
    </div>

    <div class="item">
      <span class="txt">库存地点：</span>
      <el-select
        v-model="fromData.inventoryId"
        @change="changeFstock"
        placeholder="请选择库存地点"
      >
        <el-option
          v-for="item in fstockList"
          :label="item.value"
          :key="item.inventoryId"
          :value="item.inventoryId"
        >
          <span style="float: left">{{ item.inventoryCode}}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.inventoryDesc}}</span>
        </el-option>
      </el-select>
    </div>

    <div class="item">
      <span class="txt">过账日期：</span>
      <el-date-picker v-model="fromData.postingDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">凭证日期：</span>
      <el-date-picker v-model="fromData.voucherDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>
    

    <div class="item">
      <span class="txt">备注：</span>
      <el-input v-model="fromData.voucherHeaderTxt" placeholder="暂无备注" ></el-input>
    </div>

  </div>
</template>

<script>
import { sendOrder,productOrder } from "api/business.js";
import { matterApi, fstockApi ,bomApi } from "api/base.js";
import prodorderInputList from 'components/matters/prodorderInputList.vue';


export default {
  components: {
    prodorderInputList
  },
  props: {
    fromData: Object,
    salesId: Number,
    selectedMatterSaleList: Array
  },
  data() {
    return {
      dialogSelectMatters:false,
      state:true,
      isLoading: false,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      restaurants: [],
      timeout: null,
      removeMark: false,
      fstockList: [], //库存地信息
      //获取库位信息
      fromFstock: {
        page: 1,
        pageSize: 10000,
        searchCriteria: {}
      },
    };
  },
  created() {
    //凭证和过账默认今天
    let nowData = new Date();
    this.$set(this.fromData, "postingDate", nowData);
    this.$set(this.fromData, "voucherDate", nowData);

  },
  computed: {},
  watch: {
      fromData: function(val) {
    //   console.log(val);
    }
  },
  mounted() {
      this.restaurants = this.loadAll();
    },
  methods: {
    async loadAll() {
      let res = await this.$post(matterApi.list, this.$store.state.getAllPage);
      if (res.status) {
          console.log(res)
        let materialList = [];
        res.data.list.forEach(item => {
          item.value =item.materialCode;
          materialList.push(item);
        });
        this.restaurants = materialList;
      } else {
        console.log(res.error);
      }
    },
    //生产订单号改变时触发
    prodOrderNoChange(val){
      alert(1)
      console.log(val)
    },
    querySearchAsync(queryString, cb) {
      let list = this.restaurants;
      console.log(list, "=====");
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(list);
      }, 1500 * Math.random());
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.materialCode
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    //取消所选v
    cancelSelect(){
      // this.$refs.selectMatter.cancelSelect();
      this.dialogSelectMatters = false;

    },
		//获取所选
		selectSdata(res){
      console.log(res)
      this.selectList = res;
      //  this.sexList=res;
    },
    //新增弹窗确定所选
    async selectMattersOk(){
      console.log(this.selectList.productOrderNo)
      let res = await this.$post(productOrder.find,{productOrderNo:this.selectList.productOrderNo});
        if(res.status){
          console.log(res)
          res.data.details.forEach((item)=>{
            if(item.recoil != null){
              console.log("反冲 =====+++++++")
              item.outboundNum=item.requireQuantity / res.data.orderQuantityTotal * (res.data.orderQuantityTotal - res.data.deliveryQty)
            }
          })
          this.$store.state.cache.ProdOrderInputList = res.data
          this.$store.state.cache.ProdOrderInputList.details.forEach((item,index)=>{
              item.projectClassify = res.data.bomDto.bomComponents[index].projectClassify
              item.bomProjectNo = res.data.bomDto.bomComponents[index].bomProjectNo
          })
          let nowData = new Date();
          this.$set(this.$store.state.cache.ProdOrderInputList, "postingDate", nowData);
          this.$set(this.$store.state.cache.ProdOrderInputList, "voucherDate", nowData);
          this.$store.state.cache.ProdOrderInputList.remainNum = res.data.orderQuantityTotal - res.data.deliveryQty
          this.$store.state.cache.ProdOrderInputList.currentShipNum = this.$store.state.cache.ProdOrderInputList.remainNum
          this.$store.state.cache.ProdOrderInputList.scrapQuantity = 0
        }else{
          this.$message.error(res.errorMsg);
        }
      // this.$store.state.cache.ProdOrderInputList = this.selectList
      this.dialogSelectMatters = false;
      this.getFstock(this.selectList.planFactoryId);
    },
    handleSelect(item) {
      console.log(item);
      this.fromData.materialId = item.materialId;
      this.fromData.materialCode = item.materialCode;
      this.fromData.materialDesc = item.materialDesc;

      this.fromData.entryUnitId = item.basicUnitId;
      this.fromData.entryUnitCode = item.basicUnitCode;
      this.fromData.entryUnitDesc = item.basicUnitDesc;

      this.fromData.basicUnitId = item.basicUnitId;
      this.fromData.basicUnit = item.basicUnitCode;
      this.fromData.basicUnitDesc = item.basicUnitDesc;

      this.fromData.bomBasicUnitId = item.basicUnitId;
      this.fromData.bomBasicUnit = item.basicUnitCode;
      this.fromData.bomBasicUnitName = item.basicUnitDesc;
    },
    //输入生产订单号触发
    async enterGetSaleData(){
      this.dialogSelectMatters = true;
    },
    //获取库位信息
    async getFstock(fid) {
      // console.log(fid)
      this.fromFstock.searchCriteria.factoryId = fid;
      let fstockList = await this.$post(fstockApi.list, this.fromFstock);
      if (!fstockList.status) return false;
      if (fstockList.data) {
        this.isFactoryInventory = false;
        this.fstockList = fstockList.data.list;
        this.fstockList.forEach(item => {
          item.value = item.inventoryCode + "-" + item.inventoryDesc;
        });
      } else {
        this.fstockList = [];
      }
    },
    //库位信息改变
    changeFstock(val) {
      let res = this.fstockList.find(v => v.inventoryId == val);
      if (res) {
        this.fromData.inventoryCode = res.inventoryCode;
        this.fromData.inventoryDesc = res.inventoryDesc;
        this.fromData.inventoryId = res.inventoryId;
      } else {
        this.fromData.inventoryCode = "";
        this.fromData.inventoryDesc = "";
        this.fromData.inventoryId = "";
      }
    },
    
    createStateFilter(queryString) {
      return state => {
        if (state.value) {
          return (
            state.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1
          );
        }
      };
    }
  },
};
</script>

<style>
</style>
